function openTab(evt, tabName) {
  var i, tabcontent, tablinks, container;
  // Find the closest parent element with the class 'tabs'
  container = evt.currentTarget.closest(".tabs");
  tabcontent = container.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none"; // Hide all tab content
  }
  tablinks = container.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", ""); // Remove 'active' class from all tabs
  }
  document.getElementById(tabName).style.display = "block"; // Show the current tab
  evt.currentTarget.className += " active"; // Add 'active' class to the current tab button
}

// Opening the first tab in each tab set by default
document.addEventListener("DOMContentLoaded", function () {
  var tabContainers = document.getElementsByClassName("tabs");
  Array.from(tabContainers).forEach(function (container) {
    var firstTab = container.getElementsByClassName("tablink")[0];
    if (firstTab) {
      firstTab.click(); // Simulate click on the first tab
    }
  });
});

var swiper = new Swiper(".categorTabsw", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesOffsetAfter: 40,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 2.4,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});
